import React from 'react';
import { Box, Divider, Drawer, Toolbar } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { PatientDetailsLayoutProps } from './types';


const useStyles = makeStyles()(theme => ({
  root: {},
  patientDetails: {
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    zIndex: 1,
  },
  patientDetailsDrawerPaper: {
    height: '90vh',
  },
  activities: {
    padding: theme.spacing(2),
  },
  assessments: {
    display: 'flex',
    width: '100%',
    '& > div': {
      flex: 1,
      borderLeft: `1px solid ${theme.palette.divider}`,
      borderBottom: `1px solid ${theme.palette.divider}`,
    }
  }
}));


export function TabletSmallPortraitLayout(props: PatientDetailsLayoutProps) {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Drawer
        anchor="top"
        disablePortal
        keepMounted
        style={{ zIndex: 1 }}
        classes={{ paper: classes.patientDetailsDrawerPaper }}
        open={props.patientDetailsExpanded}
        onClose={() => props.setPatientDetailsExpanded?.(false)}
        slotProps={{
          paper: { elevation: 0 }
        }}
      >
        <Toolbar />
        {props.patientDetails}
        <Divider />
        <Box>
          {props.patientAccordions}
        </Box>
        <Box className={classes.assessments}>
          {props.assessments}
        </Box>
      </Drawer>
      <Box className={classes.patientDetails}>
        {props.patientDetails}
        <Divider />
      </Box>
      <Box className={classes.activities}>
        {props.activities}
      </Box>
    </Box>
  );
}
